export default {
  success: false,
  periods: [],
  next_periods_url: "/period",
  shouldAppend: true,
  search_keyword: "",
  search_station: undefined,
};
